<template>
  <nav
    v-if="subMenu && subMenu.length"
    class="sidebar-menu menu"
    :aria-label="texts.menuLabel"
  >
    <MenuList
      :baseApiUrl="baseApiUrl"
      :menuItems="subMenu"
      :rootPageId="rootPageId"
      :currentPageId="currentPageId"
      :currentActiveId="currentActiveId"
      :parentId="rootPageId"
      :parentPageUrl="rootPageUrl"
      :path="path"
      :level="level"
      :showLinksText="texts.showLinksText"
      @setActiveLink="setActiveLink"
      @loadPartialView="loadPartialView"
    ></MenuList>
  </nav>
</template>

<script>
import { computed } from "vue";
import MenuList from "./components/MenuList.vue";
import menuservice from "../plugins/menuservice";
import loadview from "../../script/loadview";

export default {
  name: "SubMenu",
  props: {
    baseApiUrl: String,
    rootPageId: Number,
    rootPageUrl: String,
    rootPageText: String,
    rootPageChildSortOrder: Number,
    rootPageIsActive: Boolean,
    currentPageId: Number,
    currentActiveId: Number,
    path: Array,
    texts: Object,
  },
  data: function () {
    return {
      subMenu: undefined,
      level: 1,
      activeLink: 0,
      activeParentLink: 0,
      currentExpanded: undefined,
    };
  },
  components: {
    MenuList,
  },
  provide() {
    return {
      menuservice: menuservice,
      activeLink: computed(() => this.activeLink),
      activeParentLink: computed(() => this.activeParentLink),
      currentExpanded: computed(() => this.currentExpanded),
    };
  },
  beforeMount() {
    this.loadMenu();
  },
  methods: {
    loadMenu: function () {
      menuservice
        .getNextLevel(
          this.baseApiUrl,
          this.rootPageId,
          this.rootPageChildSortOrder,
          [],
          [],
          "",
          true
        )
        .then((result) => {
          if (result && result.status === 200) {
            let data = result.data;
            let root = {
              hasActiveChildren: false,
              hasChildren: false,
              isActive: this.rootPageIsActive,
              id: this.rootPageId,
              name: this.rootPageText,
              url: this.rootPageUrl,
            };
            let menu = [root];
            menu.push(...data.menuItems);
            this.subMenu = menu;
          }
        });
    },
    setActiveLink: function (id, parentId, target) {
      this.activeLink = id;
      this.activeParentLink = parentId;
      this.currentExpanded = target;
    },
    loadPartialView: function (url, push) {
      menuservice.loadPartialView(url).then((response) => {
        loadview.loadPartialView(response, push, url, this.texts.navigatedText);
      });
    },
  },
};
</script>
